import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { addTransaction, setSelectedTransaction, setWholeTransaction, updateTransaction } from "../store/appSlice";
import request from "../apis/request";
import { APIResponse } from "../types/apiTypes";
import { Transaction } from "../types";

export const useTransaction = () => {
  const {wholeTransactions, userInfo} = useSelector((state: RootState) => state.app);
  const dispatch = useDispatch();

  const onSaveTransaction = async (transaction:Transaction) => {
    try {
      const response = await request<
            APIResponse<Transaction, Partial<Transaction>>
          >({
            method: "POST",
            url: "addTransaction",
            data: transaction as Transaction,
            requireAuth: true,
            token: userInfo?.token,
          });
      const { success, message, data: newTransaction } = response.data;
      console.log("add transactions:", success, message, newTransaction);
    
      dispatch(addTransaction(newTransaction));
    } catch (error) {
      throw new Error(`取引保存中 error, ${error}`);
    }
  }

  const onUpdateTransaction = async (transaction: Transaction) => {
      try {
        const response = await request<
          APIResponse<Transaction, Partial<Transaction>>
        >({
          method: "PUT",
          url: "updateTransaction",
          data: transaction as Transaction,
          requireAuth: true,
          token: userInfo?.token,
        });
  
        const { success, message, data: newTransaction } = response.data;
        console.log("update transactions:", success, message, newTransaction);
  
        dispatch(updateTransaction(newTransaction));
      } catch (error) {
        throw new Error(`取引を更新失敗: ` + error);
      }
    };
  
    const _deleteTransaction = async (id: string) => {
      try {
        await request<APIResponse<Transaction, { id: string }>>({
          method: "DELETE",
          url: "deleteTransaction",
          data: { id: id },
          requireAuth: true,
          token: userInfo?.token,
        });
      } catch (error) {
        throw error;
      }
    };
  
    const onDeleteTransaction = async (transaction: Transaction) => {
      try {
        _deleteTransaction(transaction.id);

        const updatedTransactions = wholeTransactions.filter(
          (tr) => tr.id !== transaction.id,
        );

        dispatch(setSelectedTransaction(null));
        dispatch(setWholeTransaction(updatedTransactions));
      } catch (error) {
        throw new Error(`取引削除中 error, ${error}`);
      }
    };
  
    const onDeleteTransactions = async (ids: readonly string[]) => {
      try {
        await Promise.all(ids.map((id) => _deleteTransaction(id)));
  
        const updatedTransactions = wholeTransactions.filter(
          (tr) => !ids.includes(tr.id),
        );

        dispatch(setSelectedTransaction(null));
        dispatch(setWholeTransaction(updatedTransactions));
      } catch (error) {
        throw new Error(`取引削除中 error, ${error}`);
      }
    };

  return {onSaveTransaction, onUpdateTransaction, onDeleteTransaction, onDeleteTransactions};
}
